import React from 'react';
// import '../../styles/women-cell/main.css'

const Main = () => {
    return (
        <div id='womenCellMain'>
            <div className="women-cell-main">
                <div className="container mt-5 mb-3 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Women Cell</h2>
                                {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                                <th>Department</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1.</td>
                                                <td>Prof. Jaimala</td>
                                                <td>Coordinator</td>
                                                <td>Department of Mathematics</td>
                                            </tr>
                                            <tr>
                                                <td>2.</td>
                                                <td>Prof. Aradhana</td>
                                                <td>Member </td>
                                                <td>Department of History</td>
                                            </tr>
                                            <tr>
                                                <td>3.</td>
                                                <td>Smt. Ruchi Bhat </td>
                                                <td>Member</td>
                                                <td>Account Section</td>
                                            </tr>
                                            <tr></tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    {/* PDF Files with Clickable Icons and Headings */}
                    <div className="row pt-5">
                        <h2 className="my-heading">Women Cell-Internal Committee</h2>
                        {/* Image Section */}
                        {/* PDF Files Section */}
                        <div className="col-md-12 mb-4">
                            {/* Heading for PDF Files */}
                            {/* <h2>Infrastructure</h2> */}
                            <br />
                            {/* PDF File Icons */}
                            <div className="row">
                                {/* Example PDF File 1 */}
                                <div className="col-md-12 mb-4">
                                    <div className="pdf-container">
                                        <iframe
                                            className="pdf-viewer"
                                            src="https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/pdf-files/women-cell.pdf"
                                            width={1200}
                                            height={600}
                                            title='women-cell'
                                        />
                                    </div>
                                </div>
                                {/* Repeat this block for other PDF files */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;